export default __webpack_public_path__ + "static/media/party-josh.004bb1ac.jpg";